import * as React from 'react';

export interface Props {
  selector: string;
  closeFn?: () => void;
  children: React.ReactNode;
}

const NativeClickListener: React.FC<Props> = ({
  closeFn,
  selector,
  children,
}: Props) => {
  React.useEffect(() => {

    const checkClose = (event: any) => {
      const container = document.querySelector(selector);
      if (container && !container.contains(event.target)) {
        closeFn?.();
      }
    };

    document.body.addEventListener('click', checkClose, { capture: true });

    return () => {
      document.body.removeEventListener('click', checkClose);
    };

  }, [closeFn, selector]);


  return (
    <div>
      { children }
    </div>
  );
}

export default NativeClickListener;
